import React from "react";
import { Radar, Plug, Trophy, ArrowRight } from "lucide-react";
import { howItWorks } from "../mock";

const iconMap = { Radar, Plug, Trophy };

export default function HowItWorks() {
  return (
    <section className="relative overflow-hidden border-t border-slate-200/80 bg-white py-20 lg:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-72 bg-gradient-to-b from-[#d4af37]/[0.06] to-transparent" />
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
            How It Works
          </p>
          <h2 className="mx-auto mt-3 max-w-3xl text-4xl font-medium tracking-tight text-[#1e1b4b] sm:text-5xl">
            Build Better, <span className="text-slate-400">Brighter Lists.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-slate-600">
            <span className="font-semibold text-[#1e1b4b]">Identify</span> →{" "}
            <span className="font-semibold text-[#1e1b4b]">Connect</span> →{" "}
            <span className="font-semibold text-[#1e1b4b]">Close</span>. Three
            coordinated stages, one unified workflow — no swivel-chair tools, no
            exported CSVs, no guesswork between steps.
          </p>
        </div>

        <div className="relative mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {/* connecting line (desktop) */}
          <div className="pointer-events-none absolute left-[8%] right-[8%] top-9 hidden h-px md:block">
            <div className="h-full w-full bg-gradient-to-r from-transparent via-[#d4af37]/40 to-transparent" />
          </div>

          {howItWorks.map((s, i) => {
            const Icon = iconMap[s.icon];
            return (
              <div
                key={s.step}
                className="group relative flex flex-col rounded-2xl border border-slate-200 bg-white p-7 transition-all hover:-translate-y-1 hover:border-[#1e1b4b]/20 hover:shadow-[0_24px_50px_-20px_rgba(30,27,75,0.18)]"
              >
                <div className="flex items-center justify-between">
                  <div className="relative z-10 flex h-12 w-12 items-center justify-center rounded-xl bg-[#1e1b4b] text-[#d4af37] shadow-[0_8px_24px_-10px_rgba(30,27,75,0.6)]">
                    <Icon className="h-5 w-5" />
                  </div>
                  <span className="font-mono text-xs font-semibold uppercase tracking-[0.18em] text-slate-300">
                    {s.step}
                  </span>
                </div>

                <h3 className="mt-6 text-2xl font-semibold tracking-tight text-[#1e1b4b]">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  {s.desc}
                </p>

                <ul className="mt-5 flex flex-col gap-2 border-t border-slate-100 pt-4">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-2 text-xs text-slate-600">
                      <ArrowRight className="h-3 w-3 text-[#d4af37]" />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
